// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message-form":"message-form___3InSH","row":"row___13sRX","full":"full___2t6PU","half":"half___2P1b2"};